import { useEffect, useState } from "react"
import shortid from "shortid"

import "../../styles/Modal.css"

import arrow_down_white from "../../images/arrow_down_white.png"
import arrow_up_white from "../../images/arrow_up_white.png"

function Modal({ currentItem, cartItem, setCartItem, cart, setCart, edit, setEdit, onClose, hoursOfOp }) {
  const [ showAdditions, setShowAdditions ] = useState(false)
  const [ showSpreads, setShowSpreads ] = useState(false)
  const [ showSauces, setShowSauces ] = useState(false)
  const [ showDressings, setShowDressings ] = useState(false)
  let additionsQuantity = Object.values(cartItem.additions).map(item => {return item.servings}).reduce((a, b) => a + b, 0)

  // State Checks
  function financial(x) {
    return Number.parseFloat(x).toFixed(2);
  }

  const calcOrderTotal = () => {
    let itemTotal = cartItem.price * cartItem.servings
    let additionsTotal
    let orderTotal

    if (Object.keys(cartItem.additions).length !== 0) {
      let additionsArr = Object.entries(cartItem.additions).map(([key, value]) => (
        cartItem.size !== "18\" Large" && cartItem.size !== "18\" Large - Gluten Free" ?
          (value.price * value.servings) * cartItem.servings :
          ((value.price * 2) * value.servings) * cartItem.servings
      ))

      additionsTotal = additionsArr.reduce((partialSum, a) => partialSum + a, 0);
    }

    if (additionsTotal !== undefined) {
      orderTotal = itemTotal + additionsTotal
    } else {
      orderTotal = itemTotal
    }

    return financial(orderTotal)
  }

  let orderTotal = calcOrderTotal()

  const checkSize = () => {
    if (currentItem.size === null || currentItem.size === undefined) {
      return null
    } else {
      return currentItem.size[0]
    }
  }

  const checkUnit = () => {
    if (currentItem.unit === null) {
      return null
    } else {
      return currentItem.unit[0]
    }
  }

  const checkUnitList = () => {
    if (currentItem.unitList === null || currentItem.unitList === undefined) {
      return null
    } else {
      return currentItem.unitList[0]
    }
  }

  useEffect(() => {
    setCartItem(c => ({...c,
      id: currentItem.id,
      name: currentItem.name,
      price: currentItem.price[0],
      total: 0,
      servings: 1,
      quantity: currentItem.quantity,
      size: checkSize(),
      unit: checkUnit(),
      unitList: checkUnitList(),
      detail: "",
      toppings: {},
      extras: {},
      additions: currentItem.addition,
      spreads: currentItem.spread,
      sauces: currentItem.sauce,
      dressings: currentItem.dressing,
      pic: currentItem.pic
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItem])

  useEffect(() => {
    if (edit === true) {
      setCartItem({...currentItem.editItem})
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit])
  
  // Change Handlers
  const handleQuantityAdd = () => {
    if (cartItem.servings === 25) {
      return null
    } else {
      return setCartItem({...cartItem,
      servings: (cartItem.servings + 1)})
    }
  }

  const handleQuantitySub = () => {
    if (cartItem.servings === 1) {
      return null
    } else {
      setCartItem({...cartItem,
      servings: (cartItem.servings - 1)})
    }
  }

  const handleAdditionsAdd = key => {
    if (cartItem.additions[key].servings === 25) {
      return null
    } else {
      setCartItem({...cartItem,
        additions: {...cartItem.additions,
          [key]: {...cartItem.additions[key],
            servings: (cartItem.additions[key].servings + 1)
          }
        }
      })
    }
  }

  const handleAdditionsSub = key => {
    if (cartItem.additions[key].servings === 0) {
      return null
    } else {
      setCartItem({...cartItem,
        additions: {...cartItem.additions,
          [key]: {...cartItem.additions[key],
            servings: (cartItem.additions[key].servings - 1)
          }
        }
      })
    }
  }

  const handleSaucesAdd = key => {
    if (cartItem.sauces[key].servings === 25) {
      return null
    } else {
      setCartItem({...cartItem,
        sauces: {...cartItem.sauces,
          [key]: {...cartItem.sauces[key],
            servings: (cartItem.sauces[key].servings + 1)
          }
        }
      })
    }
  }

  const handleSaucesSub = key => {
    if (cartItem.sauces[key].servings === 0) {
      return null
    } else {
      setCartItem({...cartItem,
        sauces: {...cartItem.sauces,
          [key]: {...cartItem.sauces[key],
            servings: (cartItem.sauces[key].servings - 1)
          }
        }
      })
    }
  }

  const handleDressingsAdd = key => {
    if (cartItem.dressings[key].servings === 25) {
      return null
    } else {
      setCartItem({...cartItem,
        dressings: {...cartItem.dressings,
          [key]: {...cartItem.dressings[key],
            servings: (cartItem.dressings[key].servings + 1)
          }
        }
      })
    }
  }

  const handleDressingsSub = key => {
    if (cartItem.dressings[key].servings === 0) {
      return null
    } else {
      setCartItem({...cartItem,
        dressings: {...cartItem.dressings,
          [key]: {...cartItem.dressings[key],
            servings: (cartItem.dressings[key].servings - 1)
          }
        }
      })
    }
  }

  const handleSpreadsAdd = key => {
    if (cartItem.spreads[key].servings === 1) {
      return null
    } else {
      setCartItem({...cartItem,
        spreads: {...cartItem.spreads,
          [key]: {...cartItem.spreads[key],
            servings: (cartItem.spreads[key].servings + 1)
          }
        }
      })
    }
  }

  const handleSpreadsSub = key => {
    if (cartItem.spreads[key].servings === 0) {
      return null
    } else {
      setCartItem({...cartItem,
        spreads: {...cartItem.spreads,
          [key]: {...cartItem.spreads[key],
            servings: (cartItem.spreads[key].servings - 1)
          }
        }
      })
    }
  }

  const handleOptionChange = e => {
    setCartItem({...cartItem,
      unitList: e.target.value
    })
  }

  const handleSizeChange = e => {
    setCartItem({...cartItem,
      size: e.target.value
    })
  }

  const handleToppingsChange = e => {
    setCartItem({...cartItem,
      toppings: {...cartItem.toppings,
        [e.target.name]: e.target.value
      }
    })
  }

  const handleExtrasChange = e => {
    setCartItem({...cartItem,
      extras: {...cartItem.extras,
        [e.target.name]: e.target.value
      }
    })
  }

  const handleDetailChange = e => {
    setCartItem({...cartItem,
      [e.target.name]: e.target.value
    })
  }

  // Close Handlers
  const closeOnEscape = e => {
    if ((e.charCode || e.keyCode) === 27) {
      onClose()
    }
  }

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscape)

    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscape)
    }
  })
  
  if (currentItem.show === false) {
    return null
  }

  if (cartItem.unitList === "3 Pcs. ($2.00)" && cartItem.name === "Garlic Knots") {
    cartItem.price = 2.00
  } else if (cartItem.unitList === "1 Pcs. ($0.75/ea)" && cartItem.name === "Garlic Knots") {
    cartItem.price = 0.75

  } else if (cartItem.name === "Build Your Own Brick Oven Pizza") {
      if (cartItem.size === "12\" Indiv." || cartItem.size === "12\" Indiv. - Gluten Free") {
      switch (cartItem.unitList) {
        case "Cheese":
          cartItem.price = 11.95
          break
        case "1 Topping":
          cartItem.price = 12.95
          break
        case "2 Topping":
          cartItem.price = 13.95
          break
        case "3 Topping":
          cartItem.price = 14.95
          break
        case "4 Topping":
          cartItem.price = 15.95
          break
        default:
          return null
      }
    } else if (cartItem.size === "18\" Large" || cartItem.size === "18\" Large - Gluten Free") {
      switch (cartItem.unitList) {
        case "Cheese":
          cartItem.price = 15.95
          break
        case "1 Topping":
          cartItem.price = 17.95
          break
        case "2 Topping":
          cartItem.price = 19.95
          break
        case "3 Topping":
          cartItem.price = 21.95
          break
        case "4 Topping":
          cartItem.price = 23.95
          break
        default:
          return null
      }
    } 
  } else if (cartItem.name !== "Build Your Own Brick Oven Pizza") {
    if (cartItem.size === "12\" Indiv." || cartItem.size === "12\" Indiv. - Gluten Free") {
      cartItem.price = currentItem.price[0]
    } else if (cartItem.size === "18\" Large" || cartItem.size === "18\" Large - Gluten Free") {
      cartItem.price = currentItem.price[1]
    }
  }    

  let finalCartItem = {
    id: cartItem.id,
    name: cartItem.name,
    price: cartItem.price,
    total: parseFloat(orderTotal),
    servings: cartItem.servings,
    quantity: cartItem.quantity,
    size: cartItem.size,
    unit: cartItem.unit,
    unitList: cartItem.unitList,
    detail: cartItem.detail,
    toppings: cartItem.toppings,
    extras: cartItem.extras,
    additions: cartItem.additions,
    spreads: cartItem.spreads,
    sauces: cartItem.sauces,
    dressings: cartItem.dressings,
    pic: cartItem.pic
  }
  
  return (
    <div className="m-overlay">
      
      <div className="m-content">

        {/* ----- Header ----- */}
        <div className="m-header">
          <h4 className="m-title">{currentItem.name}</h4>
          <button className="m-cancel-button-x" onClick={onClose}>X</button>
        </div>

        {/* ----- Body ----- */}
        <div className="m-body">
          {/* ----- Body Left (Open) ----- */}
          <div className="m-body-left">
            <div className="m-body-left-image-container">
              {currentItem.pic !== null ?
                <img className="m-image" src={currentItem.pic} alt="dining item" /> :
                <img className="m-image" src="https://picsum.photos/720/480" alt="dining item" />
              }
            </div>
          </div>
          {/* ----- Body Left (Close) ----- */}

          {/* ----- Body Right (Open) ----- */}
          <div className="m-body-right">
            {/* ----- Section Content (Servings) ----- */}
            <div className="m-body-right-section">
              <div className="m-section-title">
                <span>Servings</span>
              </div>

              <div className="m-section-content-container">
                <div className="m-section-content">
                  <div className="m-content-left">
                    <span>Quantity</span>
                  </div>

                  <div className="m-content-right">
                    <button className={cartItem.servings === 1 ? "m-quan-button-disable" : "m-quan-button"} onClick={handleQuantitySub}>-</button>
                    <span className="m-quan-span">{cartItem.servings}</span>
                    <button className={cartItem.servings === 25 ? "m-quan-button-disable" : "m-quan-button"} onClick={handleQuantityAdd}>+</button>
                  </div>
                </div>
              </div>
            </div>

            {/* ----- Section Content (Size) ----- */}
            {currentItem.size !== null && currentItem.size !== undefined ?
              <div className="m-body-right-section">
                <div className="m-section-title">
                  <span>Size</span>
                </div>

                <div className="m-section-content-container">
                  {currentItem.size.length > 1 ? currentItem.size.map(item => (
                    <div className="m-section-content" key={shortid.generate()}>
                      <div className="m-content-left">
                        <span>{currentItem.quantity}{item}</span>
                      </div>

                      <div className="m-content-right">
                        <input 
                          type="radio"
                          id="size"
                          name="size"
                          value={item}
                          onChange={handleSizeChange}
                          checked={cartItem.size === item ? true : false}
                        />
                      </div>
                    </div>
                  )) :
                  <div className="m-section-content" key={shortid.generate()}>
                      <div className="m-content-left">
                        <span>{currentItem.quantity}{currentItem.size}</span>
                      </div>

                      <div className="m-content-right">
                        <input 
                          type="radio"
                          id="size"
                          name="size"
                          value={currentItem.size}
                          onChange={handleSizeChange}
                          checked
                        />
                      </div>
                    </div>}
                </div>
              </div> : null}

            {/* ----- Section Content (Options) ----- */}
            {currentItem.unitList !== null && currentItem.unitList !== undefined && currentItem.unit[0] !== "Pizza" ?
              <div className="m-body-right-section">
                <div className="m-section-title">
                  <span>Options</span>
                </div>

                <div className="m-section-content-container">
                  {currentItem.unitList.length > 1 ? currentItem.unitList.map(item => (
                    <div className="m-section-content" key={shortid.generate()}>
                      <div className="m-content-left">
                        <span>{currentItem.quantity}{item}</span>
                      </div>

                      <div className="m-content-right">
                        <input 
                          type="radio"
                          id="option"
                          name="unit"
                          value={item}
                          onChange={handleOptionChange}
                          checked={cartItem.unitList === item ? true : false}
                        />
                      </div>
                    </div>
                  )) :
                  <div className="m-section-content" key={shortid.generate()}>
                      <div className="m-content-left">
                        <span>{currentItem.quantity}{currentItem.unitList}</span>
                      </div>

                      <div className="m-content-right">
                        <input 
                          type="radio"
                          id="option"
                          name="unit"
                          value={currentItem.unitList}
                          onChange={handleOptionChange}
                          checked
                        />
                      </div>
                    </div>}
                </div>
              </div> : null}

            {/* ----- Section Content (Toppings) ----- */}
            {currentItem.note !== null && currentItem.note[0] !== 'Additional toppings (12" $1.00)/(18" $2.00)' ?
              <div className="m-body-right-section">
                <div className="m-section-title">
                  <span>Toppings</span>
                </div>

                <div className="m-section-content-container">
                  {currentItem.note.map(item => (
                    <div className="m-section-content" key={shortid.generate()}>
                      <div className="m-content-left">
                        <span>{item}</span>
                      </div>

                      <div className="m-content-right">
                        <div className="m-toppings-container">
                          <button 
                            className={cartItem.toppings[item] === `NO ${item}` ? "m-toppings-button" : "m-toppings-button-disable"} 
                            name={item} 
                            value={`NO ${item}`} 
                            onClick={handleToppingsChange}>None</button>
                          <button 
                            className={
                              cartItem.toppings[item] !== `NO ${item}` ? "m-toppings-button" : "m-toppings-button-disable"}
                            name={item} 
                            value="" 
                            onClick={handleToppingsChange}>+</button>                          
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
            </div> : null}

            {/* ----- Section Content (Extras/BYOP Toppings) ----- */}
            {currentItem.extra !== null && currentItem.extra !== undefined && Object.keys(currentItem.extra).length > 0 && currentItem.name !== "Build Your Own Brick Oven Pizza" ?
              <div className="m-body-right-section">
                <div className="m-section-title">
                  <span>Extras</span>
                </div>

                <div className="m-section-content-container">
                  {currentItem.extra.map(item => (
                    <div className="m-section-content" key={shortid.generate()}>
                      <div className="m-content-left">
                        <span>{item}</span>
                      </div>

                      <div className="m-content-right">
                        <div className="m-toppings-container">
                          <button 
                            className={cartItem.extras[item] === `ADD ${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                            name={item} 
                            value="" 
                            onClick={handleExtrasChange}>None</button>
                          <button 
                            className={cartItem.extras[item] !== `ADD ${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                            name={item} 
                            value={`ADD ${item}`} 
                            onClick={handleExtrasChange}>Add</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div> : 

              // BYOP
              currentItem.name === "Build Your Own Brick Oven Pizza" ? 
              <div className="m-body-right-section">
                <div className="m-section-title">
                  {cartItem.unitList === "Cheese" ?
                    <span>{`Toppings: ${cartItem.unitList}`}</span> : 
                    cartItem.unitList === "1 Topping" ?
                      <span>{`Toppings: choose ${cartItem.unitList}`}</span> :
                      <span>{`Toppings: choose ${cartItem.unitList}s`}</span>}
                </div>

                <div className="m-section-content-container">
                  {currentItem.extra.map(item => (
                    <div className="m-section-content" key={shortid.generate()}>
                      <div className="m-content-left">
                        <span>{item}</span>
                      </div>

                      <div className="m-content-right">

                        {/* Cheese */}
                        {cartItem.unitList === "Cheese" || cartItem.unitList === "ABC" ?
                          <div className="m-toppings-container">
                            <button 
                              className="m-toppings-button-disable"
                              name={item} 
                              value="" >None</button>
                            <button 
                              className="m-toppings-button-disable"
                              name={item} 
                              value={`${item}`} >Add</button>
                          </div> : null}

                        {/* 1 Topping */}
                        {cartItem.unitList === "1 Topping" ?
                          Object.values(cartItem.extras).filter(value => value !== "").length < 1 ?
                            <div className="m-toppings-container">
                              <button 
                                className={cartItem.extras[item] === `${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                                name={item} 
                                value="" 
                                onClick={handleExtrasChange}>None</button>
                              <button 
                                className={cartItem.extras[item] !== `${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                                name={item} 
                                value={`${item}`} 
                                onClick={handleExtrasChange}>Add</button>
                            </div> :
                            <div className="m-toppings-container">
                              <button 
                                className={cartItem.extras[item] === `${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                                name={item} 
                                value="" 
                                onClick={handleExtrasChange}>None</button>
                              <button 
                                className={cartItem.extras[item] !== `${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                                name={item} 
                                value={`${item}`}>Add</button>
                            </div>
                        : null}

                        {/* 2 Toppings */}
                        {cartItem.unitList === "2 Topping" ?    
                          Object.values(cartItem.extras).filter(value => value !== "").length < 2 ?
                            <div className="m-toppings-container">
                              <button 
                                className={cartItem.extras[item] === `${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                                name={item} 
                                value="" 
                                onClick={handleExtrasChange}>None</button>
                              <button 
                                className={cartItem.extras[item] !== `${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                                name={item} 
                                value={`${item}`} 
                                onClick={handleExtrasChange}>Add</button>
                            </div> :
                            <div className="m-toppings-container">
                              <button 
                                className={cartItem.extras[item] === `${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                                name={item} 
                                value="" 
                                onClick={handleExtrasChange}>None</button>
                              <button 
                                className={cartItem.extras[item] !== `${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                                name={item} 
                                value={`${item}`}>Add</button>
                            </div>
                        : null}

                        {/* 3 Toppings */}
                        {cartItem.unitList === "3 Topping" ?    
                          Object.values(cartItem.extras).filter(value => value !== "").length < 3 ?
                            <div className="m-toppings-container">
                              <button 
                                className={cartItem.extras[item] === `${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                                name={item} 
                                value="" 
                                onClick={handleExtrasChange}>None</button>
                              <button 
                                className={cartItem.extras[item] !== `${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                                name={item} 
                                value={`${item}`} 
                                onClick={handleExtrasChange}>Add</button>
                            </div> :
                            <div className="m-toppings-container">
                              <button 
                                className={cartItem.extras[item] === `${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                                name={item} 
                                value="" 
                                onClick={handleExtrasChange}>None</button>
                              <button 
                                className={cartItem.extras[item] !== `${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                                name={item} 
                                value={`${item}`}>Add</button>
                            </div>
                        : null}

                        {/* 4 Toppings */}
                        {cartItem.unitList === "4 Topping" ?    
                          Object.values(cartItem.extras).filter(value => value !== "").length < 4 ?
                            <div className="m-toppings-container">
                              <button 
                                className={cartItem.extras[item] === `${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                                name={item} 
                                value="" 
                                onClick={handleExtrasChange}>None</button>
                              <button 
                                className={cartItem.extras[item] !== `${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                                name={item} 
                                value={`${item}`} 
                                onClick={handleExtrasChange}>Add</button>
                            </div> :
                            <div className="m-toppings-container">
                              <button 
                                className={cartItem.extras[item] === `${item}` ? "m-toppings-button-disable" : "m-toppings-button"} 
                                name={item} 
                                value="" 
                                onClick={handleExtrasChange}>None</button>
                              <button 
                                className={cartItem.extras[item] !== `${item}` ? "m-toppings-button-disable" : "m-toppings-button"}
                                name={item} 
                                value={`${item}`}>Add</button>
                            </div>
                          : null}
                      </div>
                    </div>
                  ))}
                </div>
              </div> : null}
              

            {/* ----- Section Content (Additions) ----- */}
            {cartItem.additions !== null && cartItem.additions !== undefined && Object.keys(cartItem.additions).length > 0 ?
              <div className="m-body-right-section">
                <div className="m-section-title-ex" onClick={() => setShowAdditions(!showAdditions)}>
                  <span>Additions</span>
                  <div className="m-arrow-container">
                    {!showAdditions ?
                      <img src={arrow_down_white} alt="Arrow down" /> :
                      <img src={arrow_up_white} alt="Arrow up" />
                    }
                  </div>
                </div>

                {showAdditions ?
                  <div className="m-section-content-container">
                    {Object.entries(cartItem.additions).map(([key, value]) => (
                      <div className="m-section-content" key={shortid.generate()}>
                        <div className="m-content-left">
                          {cartItem.size !== "18\" Large" && cartItem.size !== "18\" Large - Gluten Free" ?
                            <span className="m-additions-price">(${(value.price * 1).toFixed(2)})</span> :
                            <span className="m-additions-price">(${(value.price * 2).toFixed(2)})</span>
                          }
                          <span>{value.name}</span>
                        </div>

                        {additionsQuantity < 4 ?
                          <div className="m-content-right">
                            <button className={value.servings === 0 ? "m-quan-button-disable" : "m-quan-button"} onClick={() => handleAdditionsSub(key)}>-</button>
                            <span className="m-quan-span">{value.servings}</span>
                            <button className={value.servings === 25 ? "m-quan-button-disable" : "m-quan-button"} onClick={() => handleAdditionsAdd(key)}>+</button>
                          </div> :
                          <div className="m-content-right">
                            <button className={value.servings === 0 ? "m-quan-button-disable" : "m-quan-button"} onClick={() => handleAdditionsSub(key)}>-</button>
                            <span className="m-quan-span">{value.servings}</span>
                            <button className={"m-quan-button-disable"}>+</button>
                          </div>
                        }
                      </div>
                    ))}
                  </div> 
                : null}

              </div>
            : null}

            {/* ----- Section Content (Spreads) ----- */}
            {cartItem.spreads !== null && cartItem.spreads !== undefined && Object.keys(cartItem.spreads).length > 0 ?
              <div className="m-body-right-section">
                <div className="m-section-title-ex" onClick={() => setShowSpreads(!showSpreads)}>
                  {cartItem.unit !== "Cheese" && cartItem.unit !== "Pizza" && cartItem.unit !== "Wings" ?
                    <span>Spreads</span> : 
                    <span>Sauces</span>
                  }
                  <div className="m-arrow-container">
                    {!showSpreads ?
                      <img src={arrow_down_white} alt="Arrow down" /> :
                      <img src={arrow_up_white} alt="Arrow up" />
                    }
                  </div>
                </div>

                {showSpreads ?
                  <div className="m-section-content-container">
                    {Object.entries(cartItem.spreads).map(([key, value]) => (
                      <div className="m-section-content" key={shortid.generate()}>
                        <div className="m-content-left">
                          <span>{value.name}</span>
                        </div>

                        <div className="m-content-right">
                          <button className={value.servings === 0 ? "m-toppings-button" : "m-toppings-button-disable"} onClick={() => handleSpreadsSub(key)}>None</button>
                          <button className={value.servings === 1 ? "m-toppings-button" : "m-toppings-button-disable"} onClick={() => handleSpreadsAdd(key)}>Add</button>
                        </div>
                      </div>
                    ))}
                  </div>
                : null}
              </div>
            : null}

            {/* ----- Section Content (Sauces) ----- */}
            {cartItem.sauces !== null && cartItem.sauces !== undefined && Object.keys(cartItem.sauces).length > 0 ?
              <div className="m-body-right-section">
                <div className="m-section-title-ex" onClick={() => setShowSauces(!showSauces)}>
                  <span>Sauces</span>
                  <div className="m-arrow-container">
                    {!showSauces ?
                      <img src={arrow_down_white} alt="Arrow down" /> :
                      <img src={arrow_up_white} alt="Arrow up" />
                    }
                  </div>
                </div>

                {showSauces ?
                  <div className="m-section-content-container">
                    {Object.entries(cartItem.sauces).map(([key, value]) => (
                      <div className="m-section-content" key={shortid.generate()}>
                        <div className="m-content-left">
                          <span>{value.name}</span>
                        </div>

                        <div className="m-content-right">
                          <button className={value.servings === 0 ? "m-quan-button-disable" : "m-quan-button"} onClick={() => handleSaucesSub(key)}>-</button>
                          <span className="m-quan-span">{value.servings}</span>
                          <button className={value.servings === 25 ? "m-quan-button-disable" : "m-quan-button"} onClick={() => handleSaucesAdd(key)}>+</button>
                        </div>
                      </div>
                    ))}
                  </div>
                : null}
              </div>
            : null}

            {/* ----- Section Content (Dressings) ----- */}
            {cartItem.dressings !== null && cartItem.dressings !== undefined && Object.keys(cartItem.dressings).length > 0 ?
              <div className="m-body-right-section">
                <div className="m-section-title-ex" onClick={() => setShowDressings(!showDressings)}>
                  <span>Dressings</span>
                  <div className="m-arrow-container">
                    {!showDressings ?
                      <img src={arrow_down_white} alt="Arrow down" /> :
                      <img src={arrow_up_white} alt="Arrow up" />
                    }
                  </div>
                </div>

                {showDressings ?
                  <div className="m-section-content-container">
                    {Object.entries(cartItem.dressings).map(([key, value]) => (
                      <div className="m-section-content" key={shortid.generate()}>
                        <div className="m-content-left">
                          <span>{value.name}</span>
                        </div>

                        <div className="m-content-right">
                          <button className={value.servings === 0 ? "m-quan-button-disable" : "m-quan-button"} onClick={() => handleDressingsSub(key)}>-</button>
                          <span className="m-quan-span">{value.servings}</span>
                          <button className={value.servings === 25 ? "m-quan-button-disable" : "m-quan-button"} onClick={() => handleDressingsAdd(key)}>+</button>
                        </div>
                      </div>
                    ))}
                  </div>
                : null}
              </div>
            : null}

            {/* ----- Section Content (Detail) ----- */}
            <div className="m-body-right-section">
              <div className="m-section-title">
                <span>Detail</span>
              </div>

              <div className="m-section-content-container">
                <div className="m-section-content">
                  <span>Special Instruction:</span>
                  <input 
                    className="m-detail" 
                    type="text" 
                    name="detail"
                    value={cartItem.detail}
                    onChange={handleDetailChange}
                    maxLength={99} />
                </div>
              </div>
            </div>

            {/* ----- Section Content (Summary) ----- */}
            <div className="m-body-right-section">
              <div className="m-section-title">
                <span>Summary</span>
              </div>

              <div className="m-section-content-container">
                <div className="m-section-content">
                  <div className="m-content-summary">
                    <div className="m-summary-snutd-container">
                      <div className="m-summary-snu">
                        <span className="m-summary-servings">({cartItem.servings})</span>
                        <span className="m-summary-name">{cartItem.name}</span>
                        {cartItem.quantity !== null || cartItem.size !== null || cartItem.unitList !== null ?
                          cartItem.name !== "Garlic Knots" ?
                            <>
                              {cartItem.size && cartItem.unitList ?
                                cartItem.name === "Build Your Own Brick Oven Pizza" ?
                                  <span className="m-summary-unit">({cartItem.quantity}{cartItem.size} {cartItem.unitList})</span> :
                                  <span className="m-summary-unit">({cartItem.quantity}{cartItem.size})</span> :
                                  cartItem.size && !cartItem.unitList ?
                                    <span className="m-summary-unit">({cartItem.quantity}{cartItem.size})</span> :
                                    <span className="m-summary-unit">({cartItem.quantity}{cartItem.unitList})</span>}
                            </> :
                            cartItem.unitList === "1 Pcs. ($0.75/ea)" ?
                              <span className="m-summary-unit">(1 Pcs.)</span> :
                              <span className="m-summary-unit">(3 Pcs.)</span>
                        : null}
                      </div>

                      <div className="m-summary-td">
                        {/* Summary Detail */}
                        {cartItem.detail !== "" ?
                          <span className="m-summary-detail">*{cartItem.detail}</span> 
                        : null}

                        {/* Summary Toppings */}
                        {cartItem.toppings !== null && cartItem.toppings !== undefined ?
                          Object.entries(cartItem.toppings).map(([key, value]) => {
                            if (value) {
                              return <span className="m-summary-toppings" key={shortid.generate()}>{value}</span>
                            } else {
                              return null
                            }
                          })
                        : null}

                        {/* Summary Extras */}
                        {cartItem.extras !== null && cartItem.extras !== undefined ?
                          Object.entries(cartItem.extras).map(([key, value]) => {
                            if (value) {
                              return <span className="m-summary-toppings" key={shortid.generate()}>{value}</span>
                            } else {
                              return null
                            }
                          })
                        : null}

                        {/* Summary Additions */}
                        {cartItem.additions !== null && cartItem.additions !== undefined ?
                          Object.entries(cartItem.additions).map(([key, value]) => {
                            if (value.servings !== 0) {
                              return <span className="m-summary-additions" key={shortid.generate()}>ADD ({value.servings}){value.name}</span>
                            } else { 
                              return null 
                            }
                          })
                        : null}

                        {/* Summary Spreads */}
                        {cartItem.spreads !== null && cartItem.spreads !== undefined ?
                          Object.entries(cartItem.spreads).map(([key, value]) => {
                            if (value.servings !== 0) {
                              return <span className="m-summary-toppings" key={shortid.generate()}>{value.name}</span>
                            } else { 
                              return null 
                            }
                          })
                        : null}

                        {/* Summary Sauces */}
                        {cartItem.sauces !== null && cartItem.sauces !== undefined ?
                          Object.entries(cartItem.sauces).map(([key, value]) => {
                            if (value.servings !== 0) {
                              return <span className="m-summary-toppings" key={shortid.generate()}>SIDE ({value.servings}){value.name}</span>
                            } else { 
                              return null 
                            }
                          })
                        : null}

                        {/* Summary Dressings */}
                        {cartItem.dressings !== null && cartItem.dressings !== undefined ?
                          Object.entries(cartItem.dressings).map(([key, value]) => {
                            if (value.servings !== 0) {
                              return <span className="m-summary-toppings" key={shortid.generate()}>SIDE ({value.servings}){value.name}</span>
                            } else { 
                              return null 
                            }
                          })
                        : null}
                      </div>                      
                    </div>

                    <div className="m-summary-p">
                      <span className="m-summary-total">Total:</span>
                      <span>${orderTotal}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ----- Body Right (Close) ----- */}
        </div>

        {/* ----- Footer ----- */}
        <div className="m-footer">
          {edit === true ?
            <div className="edit-note-container">
              <span className="edit-note">Attention!</span><span>After editing, please select</span><span className="edit-note-button">Add to Order.</span><br/> 
              <span className="edit-note-button">Cancel</span><span> will remove the item from your cart!</span>
            </div>
          : null}
          <div className="m-cancel-order-button-container">
            <button className="m-cancel-button" onClick={onClose}>Cancel</button>
            {hoursOfOp ?
              <button className="m-order-button" onClick={() => {
                finalCartItem.id = (finalCartItem.id + shortid.generate())
                setCart([...cart, finalCartItem])
                setEdit(false)
                onClose()
                }} >Add to Order
              </button> :
              <button className="m-cancel-button">Add to Order</button>
            }
          </div>
        </div>

      </div>

    </div>
  )
}

export default Modal
